import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigAdmin";
import Constant from "../../constants";
import { Link } from "react-router-dom";

export default class CreateOperationsUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        name: "",
        mobile_number: "",
        email: "",
        password: "",
        status: "",
      },
      errors: {},
      type: "password",
      img: "/images/doctor-img/Login screens/hide_icon.svg",
      pageHeading: "Create Operations User",
    };
  }

  // To get details after first render
  componentDidMount() {
    const { handle } = this.props.match.params;
    if (handle) {
      this.setState({ pageHeading: "Update Operations User" });
      this.getOperationsUserInfo(handle);
    }
  }

  // When the value of a field changes
  handleChange = (field, event) => {
    const value = event.target.value;
    this.setState((prevState) => ({
      fields: {
        ...prevState.fields,
        [field]: value,
      },
    }));
  };

  //  The server never returns the stored password, so it stays blank here and
  //  is only sent when the admin actually types a new one.
  getOperationsUserInfo(handle) {
    Httpconfig.httptokenget(Constant.siteurl + "api/Operations/" + handle)
      .then((response) => {
        const data = response.data.data;
        if (!data) {
          toast.error(response.data.message);
          return;
        }
        //  status arrives as a number; the radios and the validation both
        //  compare it as a string.
        this.setState((prevState) => ({
          fields: {
            ...prevState.fields,
            ...data,
            status: String(data.status),
            password: "",
          },
        }));
      })
      .catch((error) => {
        this.handleRequestError(error);
      });
  }

  //  Only the Super Admin tier may manage roles - the server answers everyone
  //  else with 403.
  handleRequestError = (error) => {
    if (error.response && error.response.status === 403) {
      toast.error("You do not have permission to manage operations users.");
      return;
    }
    toast.error("Something went wrong, please try later.");
  };

  // create or update
  checkSubmit = (event) => {
    event.preventDefault();
    const { handle } = this.props.match.params;
    if (this.handleValidation()) {
      if (handle) {
        this.updateOperationsUser();
      } else {
        this.createOperationsUser();
      }
    } else {
      toast.warn("Form has errors.");
    }
  };

  createOperationsUser = () => {
    const { fields } = this.state;
    Httpconfig.httptokenpost(Constant.siteurl + "api/Operations/", {
      name: fields.name,
      mobile_number: fields.mobile_number,
      email: fields.email,
      password: fields.password,
      status: fields.status,
    })
      .then((response) => {
        if (response.data.status === 204 || response.data.error) {
          toast.error(response.data.message);
          return;
        }
        toast.success("Successfully Created Operations User");
        setTimeout(
          () => this.props.history.push("/admin/ViewOperationsUsers"),
          1000
        );
      })
      .catch((error) => {
        this.handleRequestError(error);
      });
  };

  updateOperationsUser = () => {
    const { fields } = this.state;
    const { handle } = this.props.match.params;

    //  An empty password means "keep the current one", so it is left out
    //  rather than sent as a blank.
    const payload = { status: fields.status };
    if (fields.password) {
      payload.password = fields.password;
    }

    Httpconfig.httptokenput(
      Constant.siteurl + "api/Operations/" + handle,
      payload
    )
      .then((response) => {
        if (response.data.error) {
          toast.error(response.data.message);
          return;
        }
        toast.success("Successfully Updated Operations User");
        setTimeout(
          () => this.props.history.push("/admin/ViewOperationsUsers"),
          1000
        );
      })
      .catch((error) => {
        this.handleRequestError(error);
      });
  };

  //  For validating the fields
  handleValidation = () => {
    const { fields } = this.state;
    const isEditMode = Boolean(this.props.match.params.handle);
    let errors = {};
    let formIsValid = true;

    //  Name, mobile and email are fixed once the user exists, so they are only
    //  validated while creating one.
    if (!isEditMode) {
      if (!fields.name) {
        formIsValid = false;
        errors.name = "Name cannot be empty";
      } else if (/\d/.test(fields.name)) {
        formIsValid = false;
        errors.name = "Please enter only letters, numbers not allowed.";
      }

      if (!fields.mobile_number) {
        formIsValid = false;
        errors.mobile_number = "Phone number cannot be empty";
      } else if (fields.mobile_number.length < 10) {
        formIsValid = false;
        errors.mobile_number = "Phone number invalid";
      }

      if (!fields.email) {
        formIsValid = false;
        errors.email = "Email cannot be empty";
      } else {
        const lastAtPos = fields.email.lastIndexOf("@");
        const lastDotPos = fields.email.lastIndexOf(".");
        if (
          !(
            lastAtPos < lastDotPos &&
            lastAtPos > 0 &&
            fields.email.indexOf("@@") === -1 &&
            lastDotPos > 2 &&
            fields.email.length - lastDotPos > 2
          )
        ) {
          formIsValid = false;
          errors.email = "Email is invalid";
        }
      }
    }

    //  While editing, a blank password keeps the existing one.
    if (!isEditMode && !fields.password) {
      formIsValid = false;
      errors.password = "Password cannot be empty";
    } else if (fields.password) {
      if (fields.password.length < 8 || fields.password.length > 20) {
        formIsValid = false;
        errors.password = "Password should contain 8-20 characters";
      } else if (
        !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).{8,20}$/.exec(
          fields.password
        )
      ) {
        formIsValid = false;
        errors.password =
          "Required one upper case, one small case, one number and one special character";
      }
    }

    if (fields.status !== "0" && fields.status !== "1") {
      formIsValid = false;
      errors.status = "Please select status";
    }

    this.setState({ errors });
    return formIsValid;
  };

  //  For showing password
  showPassword = () => {
    this.setState((prevState) => ({
      type: prevState.type === "input" ? "password" : "input",
      img:
        prevState.type === "input"
          ? "/images/doctor-img/Login screens/hide_icon.svg"
          : "/images/doctor-img/Login screens/unhide_icon.svg",
    }));
  };

  render() {
    const { handle } = this.props.match.params;
    const isEditMode = Boolean(handle);
    return (
      <section id="main_dashboard">
        <div className="container" id="main_front">
          <div className="row">
            <div className="col-md-12">
              <div className="dash-section">
                <div className="section-header">
                  <ol className="breadcrumb">
                    <li className="active">
                      <Link to="/admin"> Dashboard</Link> &gt;
                      <Link to="/admin/ViewOperationsUsers">
                        {" "}
                        Operations Users{" "}
                      </Link>
                    </li>
                  </ol>
                </div>
              </div>

              <section id="CMS_tab">
                <div className="CMS_content">
                  <div className="container">
                    <div className="row">
                      <div className="tab-header">
                        <h3>{this.state.pageHeading} </h3>
                      </div>
                      <div id="reg_form">
                        <form onSubmit={this.checkSubmit.bind(this)}>
                          <div className="row">
                            <div className="col-md-3">
                              <div className="form-group ">
                                <label>Name</label>
                                <input
                                  name="name"
                                  value={this.state.fields["name"] || ""}
                                  onChange={this.handleChange.bind(this, "name")}
                                  className="form-control"
                                  placeholder="Name"
                                  type="text"
                                  disabled={isEditMode}
                                />
                                <span className="cRed">
                                  {this.state.errors["name"]}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-3">
                              <div className="form-group">
                                <label>Mobile Number</label>
                                <input
                                  type="text"
                                  name="mobile_number"
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  minLength="10"
                                  maxLength="10"
                                  value={
                                    this.state.fields["mobile_number"] || ""
                                  }
                                  onChange={this.handleChange.bind(
                                    this,
                                    "mobile_number"
                                  )}
                                  className="form-control"
                                  placeholder="Mobile Number"
                                  disabled={isEditMode}
                                />
                                <span className="cRed">
                                  {this.state.errors["mobile_number"]}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-3">
                              <div className="form-group">
                                <label>Email</label>
                                <input
                                  type="text"
                                  name="email"
                                  autoComplete="new-password"
                                  value={this.state.fields["email"] || ""}
                                  onChange={this.handleChange.bind(
                                    this,
                                    "email"
                                  )}
                                  className="form-control"
                                  placeholder="Email"
                                  disabled={isEditMode}
                                />
                                <span className="cRed">
                                  {this.state.errors["email"]}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-3">
                              <div className="form-group ">
                                <label>
                                  Password
                                  {isEditMode ? " (leave blank to keep)" : ""}
                                </label>
                                <input
                                  type={this.state.type}
                                  name="password"
                                  autoComplete="new-password"
                                  value={this.state.fields["password"] || ""}
                                  onChange={this.handleChange.bind(
                                    this,
                                    "password"
                                  )}
                                  className="form-control log_input"
                                  placeholder="Password"
                                />
                                <img
                                  className="password_view"
                                  onClick={this.showPassword}
                                  src={this.state.img}
                                />
                                <span className="cRed">
                                  {this.state.errors["password"]}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-4 cr_mid">
                              <div className="form-group ">
                                <label className="custom-control-label">
                                  Status
                                </label>
                                <div
                                  className="custom-control custom-radio"
                                  onChange={this.handleChange.bind(
                                    this,
                                    "status"
                                  )}
                                >
                                  <input
                                    type="radio"
                                    value="1"
                                    checked={this.state.fields["status"] == "1"}
                                    name="status"
                                  />{" "}
                                  Active &nbsp;&nbsp;&nbsp;
                                  <input
                                    type="radio"
                                    value="0"
                                    checked={this.state.fields["status"] == "0"}
                                    name="status"
                                  />{" "}
                                  In Active
                                  <span className="cRed">
                                    {this.state.errors["status"]}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="form-group col-md-12">
                              <button
                                type="submit"
                                className="btn  btn-primary save_btn"
                              >
                                Save User
                              </button>{" "}
                              &nbsp;
                              <Link
                                to="/admin/ViewOperationsUsers"
                                className="cancel_btn"
                              >
                                Cancel
                              </Link>{" "}
                              &nbsp; &nbsp;
                            </div>
                          </div>
                        </form>
                      </div>
                      <ToastContainer />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
